import CategoryPage from './CategoryPage';

const GalvanizadosPage = () => <CategoryPage category="galvanizados" />;

export default GalvanizadosPage;
